"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Language_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var Language_Factory = /** @class */ (function () {
    function Language_Factory() {
    }
    Language_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CultureString: model.CultureString,
            Description: model.Description,
        };
        return result;
    };
    Language_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CultureString: model.CultureString,
            Description: model.Description,
        };
        return result;
    };
    return Language_Factory;
}());
exports.Language_Factory = Language_Factory;
